import React, { useContext } from 'react';
import './PaymentMethod.css';
import { TranslationContext } from '../../../assets/contexts/translationContext';

import bank from '../../../assets/images/mainPbl/payment/unibank.webp';
import apple from '../../../assets/images/mainPbl/payment/apple.webp';
import code from '../../../assets/images/mainPbl/payment/code.webp';

import green from '../../../assets/images/mainPbl/payment/green.webp'
import light from '../../../assets/images/mainPbl/payment/light.webp'

function PaymentMethod({ language }) {
    const { mainPbl } = useContext(TranslationContext);
    const { mainPaymentMethod } = mainPbl;
    const { cards, greenBlock } = mainPaymentMethod;

    const CARDS = [
        {
            title: cards.firstCard.title,
            desc: cards.firstCard.desc,
            img: bank
        },
        {
            title: cards.secondCard.title,
            desc: cards.secondCard.desc,
            img: apple
        },
        {
            title: cards.firthCard.title,
            desc: cards.firthCard.desc,
            img: code
        }
    ]

    return (
        <div className='payment-method'>
            <p className='payment-method__title'>{mainPaymentMethod?.title}</p>
            <p className='payment-method__subtitle'>{mainPaymentMethod.subtitle}</p>
            <div className={`payment-method__green-block ${language === 'EN' ? 'payment-method__green-block_en' : ''}`}>
                <div style={{ position: 'relative' }}>
                    <img src={green} className={`payment-method__green-block__img`} />
                    <p className={`payment-method__green-block__img__pay-text ${language === 'EN' ? 'payment-method__green-block__img__pay-text_en' : ''}`}>{greenBlock.payText}</p>
                    <p className='payment-method__green-block__img__total-text'>{greenBlock.totalText}</p>
                    <img src={light} className='payment-method__green-block__img_light' />
                </div>
                <div className='payment-method__green-block__text-block'>
                    <p className='payment-method__green-block__title'>{greenBlock.title}</p>
                    <p className='payment-method__green-block__subtitle'>{greenBlock.subtitle}</p>
                </div>
            </div>
            <div className='payment-method__cards-grid'>
                {CARDS.map((item, i) => {
                    return (
                        <div className={`payment-method__card payment-method__card-${i}`}>
                            <img src={item.img}></img>
                            <div className='payment-method__card__text-box'>
                                <p className='payment-method__card__title' dangerouslySetInnerHTML={{ __html: item.title }} />
                                <p className='payment-method__card__desc'>{item.desc}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default PaymentMethod